<template>
  <div
    class="flex cursor-pointer select-none border-b border-s-400 py-3 text-base font-normal"
    :class="item?.menuStyle"
    data-testid="menu-mobile-item"
    @click="$emit('handleClick', item)"
  >
    <div class="flex flex-grow items-center justify-between font-normal">
      <slot>
        <div class="flex flex-row items-center justify-center gap-2">
          <component :is="item?.icon" v-if="item?.icon" class="h-5 w-auto" />
          {{ item?.name }}
        </div>
        <IconRightAngle v-if="hasAnyChild(item)" class="h-4 w-4" />
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconRightAngle from 'assets/icons/angle-right.svg'

defineEmits(['handleClick'])
defineProps<{
  item?: {
    name: string
    icon: string
    memberships: string[]
    children: any[]
    groups: any[]
    menuStyle: string
    if_callback: () => boolean
  }
}>()

const hasAnyChild = (menu) => {
  return menu?.children?.length || menu?.groups?.length
}
</script>
